<template>
  <ul class="user-condition-panel">
    <template v-for="(id, i) in conditions">
      <and-condition
        :key="id"
        v-model="conditionMap[id].conditions"
        :type="conditionMap[id].type"
        :ref="'andCondition' + id"
        @delete="onDel(id)"
        @change="onChange"
      ></and-condition>
      <li :key="id" v-if="i < conditions.length - 1" class="line">并且</li>
    </template>
    <condition-tag-group
      :showPrefix="conditions.length > 0"
      v-show="conditions.length < conditionsMax"
      @add="addCondition"
    ></condition-tag-group>
  </ul>
</template>

<script>
import AndCondition from './andCondition'
import ConditionTagGroup from './tagGroup'
import { util } from '../../utils'
export default {
  name: 'userConditionPanel',
  components: {
    ConditionTagGroup,
    AndCondition
  },
  props: {
    value: null
  },
  data() {
    return {
      conditionsMax: 8,
      conditions: [],
      conditionMap: {}
    }
  },
  mounted() {
    if (this.value) {
      this.initData()
    }
  },
  methods: {
    validate() {
      let result = {
        valid: true,
        errorMsg: ''
      }
      if (this.conditions.length) {
        for (let i = 0; i < this.conditions.length; i++) {
          let id = this.conditions[i]
          let andCondition = this.$refs['andCondition' + id]
          for (let j = 0; j < andCondition.length; j++) {
            let orCondition = andCondition[j]
            let valid = orCondition.validate()
            if (!valid.valid) {
              result = valid
              return result
            }
          }
        }
      } else {
        result = {
          valid: false,
          errorMsg: '群组条件不能为空'
        }
      }
      return result
    },
    initData() {
      this.conditions = []
      this.conditionMap = {}
      if (this.value && this.value.length) {
        this.value.forEach(conditions => {
          let id = util.guid()
          let type = 'user'
          if (conditions[0].eventId >= 0) {
            type = 'event'
          } else {
            switch (conditions[0].eventId) {
              case '-3':
              case -3:
                type = 'new'
                break
              case '-4':
              case -4:
                type = 'active'
                break
            }
          }
          this.conditions.push(id)
          this.conditionMap[id] = {
            type: type,
            conditions: conditions
          }
        })
      }
    },
    addCondition(type) {
      let id = util.guid()
      this.conditions.push(id)
      this.conditionMap[id] = {
        type,
        conditions: []
      }
    },
    onChange() {
      let result = this.conditions.map(id => {
        return this.conditionMap[id].conditions
      })
      this.$emit('input', result)
    },
    onDel(id) {
      this.conditions.forEach((item, i) => {
        if (id === item) this.conditions.splice(i, 1)
      })
      delete this.conditionMap[id]
      this.onChange()
    }
  }
}
</script>

<style lang="sass">
@import "./styles/conditionPanel"
</style>
